import { SELECT_ACCOUNT } from "codes";
import {
  setAppPermission,
  setAppState,
  setRole,
} from "redux/reducers/appStatesReducer";
import type { AppDispatch } from "redux/store";
import { ACCOUNTS_LIST_PERMISSION } from "./viewContext";

export const accountsListViewRole = () => ({
  id: ACCOUNTS_LIST_PERMISSION,
  name: "Accounts",
  permission: [] as string[],
  role: ACCOUNTS_LIST_PERMISSION,
});

/** Redux state when internal user opens the multi-account picker (/accounts). */
export function dispatchAccountsListViewContext(dispatch: AppDispatch) {
  dispatch(setAppState(SELECT_ACCOUNT));
  dispatch(setAppPermission(ACCOUNTS_LIST_PERMISSION));
  dispatch(setRole(accountsListViewRole()));
}
